<div class="theme-light">
  <router-outlet></router-outlet>

  <!-- add-parent-portal-pwa 2.1: a new deployed version is ready. -->
  @if (appUpdate.updateAvailable()) {
    <div class="update-bar" role="status" data-testid="app-update-bar">
      <span>A new version of the portal is available.</span>
      <button type="button" (click)="appUpdate.reloadForUpdate()">Reload</button>
    </div>
  }
</div>

